import { __rest } from "tslib";
import React, { useState, useCallback } from 'react';
import { Tooltip } from 'antd';
import { apiHolder as api, locationHelper } from 'api';
import WriteLetter from '@web-mail/components/WriteLetter/WriteLetter';
import WriteLetterIcon from '@web-common/components/UI/Icons/svgs/WriteLetterSvg';
import { useAppSelector, useActions, userAppSelectorShallowEqual } from '@web-common/state/createStore';
import { MailActions } from '@web-common/state/reducer';
import { getBodyFixHeight } from '@web-common/utils/constant';
import SideContentLayout from './sideContentLayout';
import style from './main.module.scss';
import { ExpandableSideContent } from './expandableSideContent';
const systemApi = api.api.getSystemApi();
const PageWritterMailToolTip = () => {
    const mails = useAppSelector(state => state.mailReducer.mails, userAppSelectorShallowEqual);
    const showWebWriteLetter = useAppSelector(state => !!state.mailReducer.showWebWriteLetter);
    const [inElectron] = useState(systemApi.isElectron());
    const mailActions = useActions(MailActions);
    const showWriteDialog = useCallback((e) => {
        e.stopPropagation();
        mailActions.doShowWebWrite(true);
    }, []);
    if (!mails || !mails.length) {
        return null;
    }
    return (React.createElement(Tooltip, { title: `${mails.length}封邮件编辑中`, placement: "left", overlayClassName: `${style.mailTooltip}` },
        React.createElement("div", { style: {
                display: mails.length && !inElectron ? '' : 'none',
            }, hidden: inElectron || !mails.length || showWebWriteLetter, className: style.letterCount, onClick: showWriteDialog },
            React.createElement(WriteLetterIcon, { stroke: "#FFFFFF" }),
            mails.length)));
};
const PageContentLayout = props => {
    const { children, from, allowDark } = props, rest = __rest(props, ["children", "from", "allowDark"]);
    const [pageLayoutStyle] = useState(() => ({
        height: 'calc(100vh - ' + (from === 'unitable-crm' ? getBodyFixHeight(true, true, true) : getBodyFixHeight(false, true, true)) + 'px)',
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        borderTopLeftRadius: from === 'apps' ? '8px' : '',
        paddingTop: from === 'disk' || from === 'mail' || from === 'apps' || from === 'coop' || from === 'unitable-crm' ? 0 : getBodyFixHeight(true, false),
        marginTop: from === 'apps' ? getBodyFixHeight(true, false) : 0,
    }));
    const renderChildren = useCallback((child) => {
        if (!React.isValidElement(child)) {
            return null;
        }
        const sideComponent = child.type === SideContentLayout ||
            child.props.SideContentLayout ||
            child.props.SideContentLayout ||
            child.type === ExpandableSideContent ||
            child.props['data-sidecontent'] ||
            child.props.ExpandableSideContent;
        if (child.type === React.Fragment && child.props.children) {
            return React.Children.map(child.props.children, renderChildren);
        }
        if (sideComponent) {
            return child;
        }
        return (React.createElement("div", { style: pageLayoutStyle, className: `${props.globalClassNameDisabled ? '' : 'page-content-layout'} ${allowDark ? style.pageContentDarkBg : style.pageContentBg}` }, child));
    }, []);
    const [parentStyle] = useState(() => (Object.assign({ display: 'flex', flex: 1, overflow: 'hidden' }, rest.style)));
    return (React.createElement("div", Object.assign({}, rest, { style: parentStyle }),
        !locationHelper.isMainPage() ? React.createElement(WriteLetter, null) : React.createElement(React.Fragment, null),
        !locationHelper.isMainPage() && React.createElement(PageWritterMailToolTip, null),
        React.Children.map(children, renderChildren)));
};
export default PageContentLayout;
